// extracted by mini-css-extract-plugin
export default {"tableContainer":"FundRepresentativesTable_tableContainer__2jeDI","userCellContainer":"FundRepresentativesTable_userCellContainer__kHaOk"};